<template>
  <div class="ticket-extra-request-checker">
    <slot v-if="showSlot"></slot>
    <div v-else>
      <div v-if="extra_request_response && !extraRequestTicketFeedback.show">
        <div class="motivation-container">
          <h1>Richiesta aggiuntiva:</h1>
          <p
            v-if="extra_request_response['motivation']"
            v-html="extra_request_response['motivation']"
          ></p>
        </div>
        <form
          class="row g-3 needs-validation text-start"
          @submit="checkForm"
          :novalidate="true"
        >
          <fileUploaderList
            ref="fileListUploader"
            :answerDetail="answerDetailAdapted"
            :ticketId="extra_request_response['id_ticket']"
            :extra_request_id="extra_request_response['id']"
            @upload-all-success="onUploadSuccess"
            @upload-all-error="onUploadError"
          />
          <recaptchaContainer ref="recaptchaContainerRef" />
          <div class="col-12 fw-bold">
            {{ intl[$store.state.lang]["privacy"] }}
            <span style="font-weight: bold">
              <a
                target="_blank"
                style="color: #008c95"
                :href="tocUrl"
                >Privacy</a
              ></span
            ><span style="font-weight: bold">*:</span>
          </div>
          <div class="col-12">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                id="validationToc"
                aria-describedby="invalidToc"
                v-model="toc"
                required
              />
              <label
                class="form-check-label"
                for="validationToc"
                v-html="terms"
              >
              </label>
              <div id="invalidToc" class="invalid-feedback">
                {{ intl[$store.state.lang]["terms-and-conditions-not-ok"] }}
              </div>
            </div>
          </div>
          <div class="col-12">
            <button
              class="btn btn-primary"
              type="submit"
              style="
                background-color: #008c95;
                border-color: #008c95;
                background-image: unset;
              "
            >
              {{ "Invia Allegato/i" }}
            </button>
          </div>
        </form>
      </div>
      <div v-else>
        <div class="row">
          <div
            v-if="
              extraRequestTicketFeedback.show &&
              extraRequestTicketFeedback.type === 'success'
            "
            class="alert alert-success"
            role="alert"
          >
            <div
              style="margin-bottom: 10px"
              v-html="extraRequestTicketFeedback.message"
            ></div>
          </div>
          <div
            v-else-if="
              extraRequestTicketFeedback.show &&
              extraRequestTicketFeedback.type === 'error'
            "
            class="alert alert-danger"
            role="alert"
          >
            <div
              style="margin-bottom: 10px"
              v-html="extraRequestTicketFeedback.message"
            ></div>
          </div>
        </div>

        <div class="row" v-if="extraRequestTicketFeedback.show">
          <button
            :onclick="this.restartQuiz"
            class="float-end btn btn-danger btn-lg col-l2"
          >
            <span class="bi-arrow-clockwise"></span
            >{{ intl[$store.state.lang]["new-quiz"] }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import intl from "./intl/intl";
import axios from "axios";
import { apiUrls } from "../../api/apiUrls";
import FileUploaderList from "../fileUploaderList/FileUploaderList.vue";
import RecaptchaContainer from "../recaptchaContainer/RecaptchaContainer.vue";
export default {
  name: "checkTicketExtraRequest",
  components: {
    fileUploaderList: FileUploaderList,
    recaptchaContainer: RecaptchaContainer,
  },
  props: {
    setPaginaLoaderCallback: {
      type: Function,
      default: (value) => {
        console.log("Pagina loader callback : ", value);
      },
    },
  },

  created() {},
  mounted() {
    if(this.$store.state.libraryWiperConfig.tocUrl){
      this.tocUrl = this.$store.state.libraryWiperConfig.tocUrl
    }
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has("extra_request")) {
      this.showSlot = true;
    } else {
      this.checkTicketExtraRequest();
    }
  },

  data: function () {
    return {
      intl: intl,
      ticketExtraRequestLoader: false,
      showSlot: false,
      extra_request_response: null,
      answer_detail_mocked: [],
      showUploaderError: false,
      recaptchaError: false,
      recaptchaWidgetId: null,
      toc: false,
      tocUrl: 'https://www.organismo-am.it/documenti/OAM-Informativa_di_base.pdf',
      terms:
        "Autorizzo il trattamento dei miei dati personali ai sensi del D.Lgs. 196/2003 e all’art. 13 GDPR 679/16.",
      extraRequestTicketFeedback: {
        show: false,
        type: "", // success o error
        message: "",
      },
    };
  },
  methods: {
    recaptchaCallback(response) {
      //console.log("reCAPTCHA response:", response);
      return;
    },
    resetExtraRequestTicketFeedback() {
      this.extraRequestTicketFeedback = {
        show: false,
        type: "", // success o error
        message: "",
      };
    },
    addFormEventListener() {
      var forms = document.querySelectorAll(".ticket-extra-request-checker .needs-validation");
      Array.prototype.slice.call(forms).forEach(function (form) {
        form.addEventListener(
          "submit",
          function (event) {
            if (!form.checkValidity()) {
              event.preventDefault();
              event.stopPropagation();
            } else {
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    },
    onUploadError(error) {
      this.extraRequestTicketFeedback.type = "error";
      this.extraRequestTicketFeedback.message =
        this.intl[this.$store.state.lang]["ticket-extraRequest-error"];
      this.extraRequestTicketFeedback.show = true;
      this.ticketExtraRequestLoader = false;
    },
    onUploadSuccess(response) {
      this.updateDoneStatus();
    },
    updateDoneStatus() {
      if (this.extra_request_response["id"]) {
        axios
          .post(apiUrls["update_done_extra_request"], {
            id: this.extra_request_response["id"],
          })
          .then((response) => {
            this.extraRequestTicketFeedback.type = "success";
            this.extraRequestTicketFeedback.message =
              this.intl[this.$store.state.lang]["ticket-extraRequest-success"];
            this.extraRequestTicketFeedback.show = true;
            this.ticketExtraRequestLoader = false;
          })
          .catch((error) => {
            this.extraRequestTicketFeedback.type = "error";
            this.extraRequestTicketFeedback.message =
              this.intl[this.$store.state.lang]["ticket-extraRequest-error"];
            this.extraRequestTicketFeedback.show = true;
            this.ticketExtraRequestLoader = false;
          });
      }
    },
    async checkForm(e) {
      if (e) e.preventDefault();
      let interruptSubmit = false
      const recaptchaResponse = await this.$refs.recaptchaContainerRef.executeRecaptcha();
      this.$refs.fileListUploader &&
        this.$refs.fileListUploader.checkAttachmentsOnCreateTicket();
      if (recaptchaResponse.length === 0) {
        interruptSubmit = true
      }

      if (
        this.$refs.fileListUploader.fileObbligatoriDaCaricare().length > 0 ||
        this.$refs.fileListUploader.esisteUnFileNonCoerente()
      ) {
        return;
      }

      if(!this.toc){
        interruptSubmit = true
      }

      if(interruptSubmit){
        return
      }

      if (
        this.$refs.fileListUploader &&
        this.$refs.fileListUploader.uploadAll
      ) {
        this.ticketExtraRequestLoader = true;
        this.$refs.fileListUploader.uploadAll(
          this.extra_request_response["id_ticket"]
        );
      }
    },

    setPaginaLoaderCallbackUploader(loaderInfo) {
      this.ticketExtraRequestLoader =
        loaderInfo["fileUploaderLoader-" + this.extra_request_response.type];
    },
    restartQuiz() {
      this.$store.dispatch("DELETE_SURVEY_LOG");

      const urlParams = new URLSearchParams(window.location.search);
      urlParams.delete("extra_request");
      let newUrl = `${window.location.origin}${window.location.pathname}`;
      if (urlParams.toString() !== "") {
        newUrl += `?${urlParams.toString()}`;
      }
      newUrl += window.location.hash;
      window.history.replaceState({}, document.title, newUrl);
      this.showSlot = true;
    },

    //QUESTO METODO ADATTA ANSWERDETAIL PER IL COMPONENTE FILEUPLOADERLIST
    fileUploaderListDataAdapter() {
      let anserDataAdapted = {
        data: {
          answerAttachmentRequired: [
            {
              id: this.extra_request_response.id,
              title: this.extra_request_response.type
                ? this.extra_request_response.type
                : "Allegato",
              required: 1,
            },
          ],
        },
      };
      return anserDataAdapted;
    },

    checkTicketExtraRequest() {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has("extra_request")) {
        const GUID = urlParams.get("extra_request");

        this.ticketExtraRequestLoader = true;

        axios
          .get(apiUrls["check_ticket_extra_request"], {
            params: {
              GUID: GUID,
            },
          })
          .then((response) => {
            this.ticketExtraRequestLoader = false;

            //SE L ALLEGATO RELATIVO AL GUID GIA' E' STATO CARICATO FAI PARTIRE IL QUESTIONARIO
            if (response.data.done == 1) {
              this.showSlot = true;
            } else {
              this.extra_request_response = response.data;
              this.answerDetailAdapted = this.fileUploaderListDataAdapter();
            }
          })
          .catch((error) => {
            if (error?.response?.status === 404) {
              this.showSlot = true;
            } else {
            }
            this.ticketExtraRequestLoader = false;
          });
      }
    },
  },
  watch: {
    ticketExtraRequestLoader: {
      handler: function (newValue, oldValue) {
        if (oldValue !== newValue) {
          this.setPaginaLoaderCallback({ ticketExtraRequest: newValue });
        }
      },
      deep: true,
    },
    extra_request_response: {
      handler: function (newValue, oldValue) {
        if (newValue) {
          this.$nextTick(() => {
            if (newValue.id && !this.extraRequestTicketFeedback.show) {
              this.addFormEventListener();
            }
          });
        }
      },
      deep: true,
    },
    /*  extra_request_response: {
      handler: function (newValue, oldValue) {
       
      },
      deep: true,
    }, */
  },
  computed: {},
  unmounted() {
    
  },
};
</script>
